<template>
<div>
  <span v-if="options && options.includes('CAR')">
    <input type="radio" id="check-car" value="CAR" name="radio-group" :checked="valueLocal === 'CAR'" @change="update()">
    <label for="check-car">{{$t('global.vehicleType.car')}}</label>
  </span>
  <span v-if="options && options.includes('MOTORCYCLE')">
    <input type="radio" id="check-motorcycle" value="MOTORCYCLE" name="radio-group" :checked="valueLocal === 'MOTORCYCLE'" @change="update()">
    <label for="check-motorcycle">{{$t('global.vehicleType.motorcycle')}}</label>
  </span>
  <span v-if="options && options.includes('MOTORCYCLE_COURIER')">
    <input type="radio" id="check-motorcycle" value="MOTORCYCLE_COURIER" name="radio-group" :checked="valueLocal === 'MOTORCYCLE_COURIER'" @change="update()">
    <label for="check-motorcycle">{{$t('global.vehicleType.motorcycle_courier')}}</label>
  </span>
  <span v-if="options && options.includes('TRUCK')">
    <input type="radio" id="check-truck" value="TRUCK" name="radio-group" :checked="valueLocal === 'TRUCK'" @change="update()">
    <label for="check-truck">{{$t('global.vehicleType.truck')}}</label>
  </span>
</div>
</template>

<script>
export default {
  props: {
    value: String,
    options: Array
  },
  created() {
    this.valueLocal = this.value
  },
  watch: {
    value() {
      this.valueLocal = this.value
    }
  },
  methods: {
    update () {
      this.valueLocal = this.$el.querySelector(':checked').value
      this.$emit('input', this.valueLocal)
    }
  }
}
</script>

<style scoped lang="scss">
@import '../assets/sass/variables';

div {
  max-width: 360px;
  text-align: center;
}

span {
  display: inline-block;
  padding: 5px 20px 20px;
  margin: 2px 0;
  width: 33%;
}


[type="radio"]:checked,
[type="radio"]:not(:checked) {
  position: absolute;
  left: -9999px;
}
[type="radio"]:checked + label,
[type="radio"]:not(:checked) + label {
  display: block;
  height: 60px;
  width: 100%;
  color: $white;
  background-repeat: no-repeat;
  background-position: center 3px;
  background-size: auto $size-3;
  cursor: pointer;
  opacity: .3;
  transition: .3s all;

  text-align: center;
  padding-top: 40px;
  font-size: $size-7;
}

#check-car + label {
  background-image: $carIcon;
}
#check-motorcycle + label {
  background-image: $motorcycleIcon;
  background-position: center top;
  background-size: auto $size-3 + .4;
}
#check-truck + label {
  background-image: $truckIcon;
}

[type="radio"]:checked + label {
  opacity: 1;
}
</style>
